<template>
  <div :class="{scrolled: doScrolled}">
    <div class="main-nav-holder" v-on:mouseenter="handleMouse(true)" v-on:mouseleave="handleMouse(false)">
      <div class="main-nav">
        <div class="logo" :class="{anim: animation}">
          <div><ix-router-link :to="currentHome"><img :src="logo.logo" :class="logoClass" :alt="logo.alt" /></ix-router-link></div>
          <div class="logo-subhead" :class="{anim: animation}">
            {{ subhead }} 
          </div>
        </div>
        <div class="flex-top">
          <div class="nav-menu">
            <div class="item" :class="{selectedMenu: !animation}"><ix-router-link to="/artists">{{ $store.state.snippets.illustrators }}</ix-router-link></div>
            <div class="item drop style-item" v-on:click.stop="showStylePopup = true" >
              <ix-router-link to="/styles" event="none">{{ $nippets.styles }}</ix-router-link>
            </div>
            <div class="item" :class="{selectedMenu: animation}" >
              <ix-router-link to="/animators">{{ $store.state.snippets.animators }}</ix-router-link></div>
          </div>
        </div>
        <div class="nav-sub-menu">
          <div class="item no-device">
            <div>
              <a :href="'tel:' + $nippets.tel.code">{{ $nippets.tel.display }}</a> | 
              <a :href="'mailto:' + email" class="lc">{{ $nippets.email }}</a>
            </div>
          </div>
          <div class="item no-device">
            <div class="mr4"><img src="../../assets/img/globe.svg" width="16px" class="globe"></div>
            <location-menu />
          </div>
          <div class="item hide-tiny" v-if="!$store.getters.signedIn">
            <small-button v-on:click="showLogin" lower>
              {{ $nippets.login }}
            </small-button>
            <small-button lower v-on:click="showSignup">
              {{ $nippets.signup }}
            </small-button>
          </div>
          <div class="item hide-tiny" v-if="$store.getters.signedIn">
            <my-area-menu />
          </div>
        </div>
        <div class="hamburger"  v-on:click="$store.commit('setShowHamburgerMenu', true)"></div>
        <hamburger-menu v-on:styleClick="showStylePopup = true" :animation="animation" />
      </div>
    </div>
    <div class="main-nav-filler"></div>
    <style-popup :visible="showStylePopup" v-on:close="handleCloseStyle" :animation="animation" />
  </div>
</template>

<script>
import HamburgerMenu from '@/components/navigation/HamburgerMenu.vue'
import StylePopup from './StylePopup.vue'
import LocationMenu from './LocationMenu.vue'

import logos from './logos.js'

export default {
  components: {
    HamburgerMenu,
    StylePopup,
    LocationMenu,
    MyAreaMenu: () => import(/* webpackChunkName: "auth" */ '@/components/navigation/MyAreaMenu.vue')
  },
  props: {
    animation: Boolean
  },
  data: function () {
    return {
      isScrolled: false,
      mouseIn: false,
      showStylePopup: false
    }
  },
  computed: {
    logoClass () {
      if(this.animation) return 'animLogo'
      return 'standardLogo'
    },
    doScrolled: function () {
      return this.isScrolled && (!this.mouseIn)
    },
    currentHome () {
      return this.animation ? '/animation': '/'
    },
    logo () {
      if(this.animation) {
        return logos.anim
      }
      return logos.illus
    },
    subhead () {
      return this.animation ? this.$nippets.animation.subhead : this.$nippets.illustration.subhead
    },
    email () {
      return this.animation ? this.$nippets.animation.email : this.$nippets.illustration.email
    },
    illustratorsOrder () {
      return this.animation ? 3 : 1
    },
    animatorsOrder () {
      return this.animation ? 1 : 3
    }
  },
  mounted: function () {
    this.checkScrolled()
    window.addEventListener('scroll', () => {
      this.checkScrolled()
    })
  },
  
  methods: {
    handleCloseStyle: function () {
      console.log('closing style browser')
      this.showStylePopup = false
    },
    checkScrolled: async function () {
      if(window.scrollY > 140) {
        this.isScrolled = true
      }
      else {
        this.isScrolled = false
      }
    },
    handleMouse: function (enter) {
      this.mouseIn = enter
    },
    showLogin() {
      this.$store.commit('showLogin')
    },
    showSignup() {
      this.$ixr.push('/my-area/signup')
    }
  }
}
</script>

<style scoped>

  .standardLogo{
    width: 315px;
  }

  .animLogo{
    width:300px;
  }

  .main-nav-holder {
    position:fixed;
    top:0;
    left:0;
    right:0;
    z-index:50;
    box-sizing:border-box;
  }

  .main-nav{
    background-color:#fff;
    padding:37px 45px 25px 45px;
    max-width:1750px;
    margin-left:auto;
    margin-right:auto;
    font-family: gibbs, sans-serif;
    font-weight: 500;
    font-style: normal;
    box-sizing:border-box;
    position:relative;
    transition:all 0.15s ease;
    height:116px;
  }

  .scrolled .main-nav{
    padding:10px 45px;
    height:65px;
  }

  .main-nav-filler{
    height:116px;
  }

  .flex-top{
    display:flex;
    align-items:center;
  }

  .nav-menu{
    margin-left:389px;
    display:flex;
    font-size:36px;
    line-height:34px;
    padding-bottom:10px;
    padding-top:10px;
  }

  .scrolled .nav-menu{
    padding-bottom:10px;
    padding-top:10px;
  }

  .nav-menu .item{
    margin:0 11px;
    cursor:pointer;
    order: 3
  }

  .nav-menu a{
    text-decoration: none;
    color:#000;
  }

  .nav-menu a.router-link-active{
    color:#ce0e2d;
  }

  .nav-menu a:hover{
    color:#ce0e2d;
  }

  .nav-menu .item:hover{
    color:#ce0e2d;
  }

  .nav-menu .item.drop {
    background-image:url('../../assets/img/maindown.svg');
    background-position:right 64%;
    background-repeat:no-repeat;
    padding-right:25px;
    background-size:18px;
  }

  .nav-menu .item.drop:hover {
    background-image:url('../../assets/img/maindown-red.svg');
  }

  

  .nav-sub-menu{
    position:absolute;
    top:14px;
    right:45px;
    color:#7a7157;
    font-size:14px;
    line-height:14px;
    display:flex;
    align-items:center;
    transition:all 0.15s ease;
  }

  .scrolled .nav-sub-menu {
    top:-30px;
  }

  .nav-sub-menu .item{
    display:flex;
    align-items:center;
    margin:0 10px;
  }

  .nav-sub-menu .item:last-child
  {
    margin-right:0;
  }

  .logo{
    position:absolute;
    left:45px;
    top:34px;
  }

  .logo.anim{
    top:30px;
  }

  .scrolled .logo{
    top:15px;
  }

  .scrolled .logo.anim{
    top:14px;
  }

  .logo-subhead{
    font-size:17px;
    font-weight:400;
    color:#7a7157;
    margin-top:0;
  }

  .logo-subhead.anim{
    font-size:16.3px;
  }

  .scrolled .logo-subhead{
    display:none;
  }
  
  .hamburger{
    position:absolute;
    top:60px;
    right:45px;
    background-image:url('../../assets/img/hamburger.svg');
    background-repeat:no-repeat;
    background-size: 38px 28px;
    background-position:center center;
    width:38px;
    height:28px;
    cursor:pointer;
    transition: all 0.15s ease;
  }

  .scrolled .hamburger{
    top:18px;
  }

  .hamburger:hover{
    background-image:url('../../assets/img/hamburger-red.svg');
    transform: scale(1.1);
  }

  .hamburger:active{
    transform: scale(1.2);
  }

  .clickover{
    cursor:pointer;
  }

  .clickover:hover{
    color:#ce0e2d;
  }

  .nav-menu .item.selectedMenu{
    order: 1;
  }

  .nav-menu .item.style-item{
    order:2;
  }

  @media screen and (max-width:1100px){
    .main-nav{
      padding-left:25px;
      padding-right:25px;
      padding-bottom:74px;
      max-width:100vw;
    }
    .scrolled .main-nav{
      padding-left:25px;
      padding-right:25px;
      padding-bottom:50px;
    }

    .logo{
      left:25px;
    }

    .hamburger{
      right:25px;
    }
    .nav-sub-menu{
      right:25px;
    }
  }

  @media screen and (max-width:1024px){
    .nav-menu{
      display:none;
    }
  }

  @media screen and (max-width:768px){
    .no-device{
      display:none!important;
    }
  }

  @media screen and (max-width:640px)
  {
    
    .main-nav{
      padding-left:10px;
      padding-right:10px;
      margin-left:0;
      margin-right:0;
      
      box-sizing:border-box;
    }
    .scrolled .main-nav{
      padding-left:10px;
      padding-right:10px;
    }

    .logo{
      left:10px;
      top:18px;
    }

    .scrolled .hamburger{
      top:20px;
    }

    .hamburger{
      top:20px;
      right:10px;
      background-size: contain;
      width:32px;
    }

    .nav-sub-menu{
      right:10px;
    }
    .nav-sub-menu .item.hide-tiny{
      display:none;
    }

    .main-nav{
      padding-top:10px;
      padding-bottom:10px;
      height:94px;
    }

    .main-nav-filler{
      height:90px;
    }
  }

  @media screen and (max-width:375px)
  {
    .standardLogo{
      width:80vw;
    }

    .hamburger{
      top:16px;
    }

    .main-nav{
      padding-top:10px;
      padding-bottom:10px;
      height:74px;
    }

    .scrolled .hamburger{
      top:16px;
    }

    .logo-subhead{
      font-size:14px;
    }
  

    .main-nav-filler{
      height:70px;
    }

    
  }
  
</style>
